import React from "react";
import { Link } from "react-router-dom";
import { useI18n } from "@/lib/i18n";
import BrandLogo from "@/components/BrandLogo";
import { Heart } from "lucide-react";

export default function AppFooter() {
  const { t } = useI18n();
  const legal = [
    { to: "/legal-info", key: "footer_legal_info", tid: "footer-legal-info" },
    { to: "/privacy", key: "footer_privacy", tid: "footer-privacy" },
    { to: "/terms", key: "footer_terms", tid: "footer-terms" },
    { to: "/community-rules", key: "footer_community_rules", tid: "footer-community-rules" },
    { to: "/marketplace-rules", key: "footer_marketplace_rules", tid: "footer-marketplace-rules" },
    { to: "/account-deletion", key: "footer_account_deletion", tid: "footer-account-deletion" },
  ];
  return (
    <footer className="mt-24 border-t border-slate-200 bg-white/60" data-testid="app-footer">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-10 grid md:grid-cols-4 gap-8">
        <div>
          <div className="mb-3">
            <BrandLogo className="h-10" />
          </div>
          <p className="text-sm text-slate-600 leading-relaxed max-w-sm">{t("footer_mission")}</p>
        </div>
        <div className="text-sm text-slate-600 space-y-2">
          <div className="text-xs uppercase tracking-[0.2em] text-slate-500 font-semibold mb-2">{t("footer_platform")}</div>
          <div>{t("footer_platform_items")}</div>
          <div>{t("footer_platform_lang")}</div>
          <div>{t("footer_platform_ai")}</div>
        </div>
        <div className="text-sm text-slate-600 space-y-2">
          <div className="text-xs uppercase tracking-[0.2em] text-slate-500 font-semibold mb-2">{t("footer_legal")}</div>
          <ul className="space-y-1.5">
            {legal.map((l) => (
              <li key={l.to}>
                <Link to={l.to} data-testid={l.tid} className="hover:text-emerald-700 hover:underline">{t(l.key)}</Link>
              </li>
            ))}
          </ul>
        </div>
        <div className="text-sm text-slate-600 space-y-2">
          <div className="text-xs uppercase tracking-[0.2em] text-slate-500 font-semibold mb-2">{t("footer_community")}</div>
          <div className="flex items-center gap-1.5"><Heart size={14} className="text-rose-500" /> {t("footer_made")}</div>
          <div className="flex items-center gap-1.5">© {new Date().getFullYear()} <BrandLogo className="h-5" /></div>
        </div>
      </div>
    </footer>
  );
}
